export default {
  all: [],
  one: {

  },
};
